<div>
  <ng-container *ngIf="SIMPublicationOverview && !loading">
    <div class="flex flex-col">
      <div class="mt-4 mb-16 ml-4">
        <div class="flex flex-col lg:flex-row text-grey-800" >
          <div class="lg:w-1/3 lg:px-4" >
            <div
              id="div-documentReference"
            >
              <label class="body-default-bold" id="sim-publication-document-reference-label">Document Reference</label>
              <p class="body-default-regular" id="sim-publication-document-reference-value">
                {{SIMPublicationOverview?.documentRef}}
              </p>
            </div>
            <div
              id="div-projectID"
            >
              <label class="body-default-bold" id="sim-publication-project-id-label">Project ID</label>
              <p class="body-default-regular" id="sim-publication-project-id-value">
                  {{SIMPublicationOverview?.projectId}}
              </p>
            </div>
            <div
              id="div-designation"
            >
              <label class="body-default-bold" id="sim-publication-designation-label">Designation</label>
              <p class="body-default-regular " id="sim-publication-designation-value">
                  {{SIMPublicationOverview?.designation}}
              </p>
            </div>
            <div
              id="div-draftDesignation"
            >
              <label class="body-default-bold" id="sim-publication-draft-designation-label">Draft Designation</label>
              <p class="body-default-regular" id="sim-publication-draft-designation-value">
                  {{SIMPublicationOverview?.draftDesignation}}
              </p>
            </div>
          </div>
          <div class="lg:w-2/3 lg:px-4">
            <div id="div-ProjectType">
              <label class="body-default-bold" id="sim-publication-project-type-label">Project Type</label>
              <p class="body-default-regular " id="sim-publication-project-type-value">
                  {{SIMPublicationOverview?.projectType}}
              </p>
            </div>
            <div
              id="div-PublicationStatus"
            >
              <label class="body-default-bold" id="sim-publication-status-label">Publication Status</label>
              <p class="body-default-regular">
                <app-sim-publication-status-badge
                        id="sim-publication-status"
                        [simPublicationStatus]= 'this.SIMPublicationOverview?.publicationStatus ?? ""'
                ></app-sim-publication-status-badge>
              </p>
            </div>
            <div
              id="div-synopsis"
            >
              <label class="body-default-bold" id="sim-publication-status-synopsis-label">Synopsis</label>
              <div class="body-default-regular" id="sim-publication-status-synopsis-value" [innerHTML]="sanitizedSynopsis">
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="loading">
      <div class="flex justify-center items-center min-h-[40vh]">
        <div *ngIf="loading">
          <app-loading-indicator [size]="32"></app-loading-indicator>
        </div>
      </div>
  </ng-container>
</div>


